
import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { ItineraryEvent } from '@/types/itinerary';
import DraggableEvent from './DraggableEvent';

interface EventListProps {
  date: string;
  events: ItineraryEvent[];
  onEdit?: (event: ItineraryEvent) => void;
  onDelete?: (eventId: string) => void;
}

const EventList: React.FC<EventListProps> = ({ date, events, onEdit, onDelete }) => {
  const hasEditPermission = !!onEdit && !!onDelete;
  
  if (!date) return null;
  
  return (
    <Droppable droppableId={date} isDropDisabled={!hasEditPermission}>
      {(provided) => (
        <div
          {...provided.droppableProps}
          ref={provided.innerRef}
          className="space-y-4"
        >
          {events.map((event, index) => (
            <DraggableEvent
              key={event.id}
              event={event}
              index={index}
              isDragDisabled={!hasEditPermission}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default EventList;
